import { Component, OnInit } from '@angular/core';
import { PrintService } from 'src/app/core/services/print.service';
import { Client } from 'src/app/shared/models/clients/client';

@Component({
  selector: 'app-print-clients',
  templateUrl: './print-clients.component.html',
  styleUrls: ['./print-clients.component.scss']
})
export class PrintClientsComponent implements OnInit {
  clients: Client[] = [];
  constructor(
    private printService: PrintService,
  ) {
    this.clients = this.printService.data;
  }

  ngOnInit(): void {
    this.printService.onDataReady('Clients');
  }

}
